import styles from './Button.module.css';

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'secondary' | 'danger';
};

export function Button({ variant, className, ...props }: ButtonProps) {
  const cls = [styles.button, variant ? styles[variant] : '', className].filter(Boolean).join(' ');
  return <button className={cls} {...props} />;
}
